import { GQLProductSideAvailableDecorationType, GQLProductSideSideType } from '@theprintbar/graphql';
import { ActionToastResponse, ActionToastType, Merch, cloneDeep, getDecorationTrueview, logError } from '@theprintbar/shared';
import { useRef } from 'react';

interface WilcomStitchesProps {
	webDomain?: string;
	setUpdatingPrice: (value: boolean) => void;
	setMerch: (merch: Merch) => void;
	setLocalToast: (toast: ActionToastResponse) => void;
}

export function useWilcomStitches({ webDomain, setUpdatingPrice, setMerch, setLocalToast }: WilcomStitchesProps) {
	const wilcomCallId = useRef<symbol[]>([]);

	const resetWilcomCallId = () => {
		wilcomCallId.current = [];
	};

	const calculateStitches = async (merch: Merch | null | undefined, activeSide?: GQLProductSideSideType) => {
		if (!merch) return;
		setUpdatingPrice(true);

		const newMerch = cloneDeep(merch);

		for (const decorationIndex in merch.decorations) {
			const decoration = merch.decorations[decorationIndex];
			if (!!activeSide && decoration.side !== activeSide) continue;
			if (!decoration.artwork?.size || decoration.type !== GQLProductSideAvailableDecorationType.Emb || !!decoration.meta.stitches)
				continue;
			const callId = Symbol();
			wilcomCallId.current.push(callId);
			try {
				const res = await getDecorationTrueview({ decoration, webDomain });
				if (!wilcomCallId.current.includes(callId)) return;

				newMerch.decorations[decorationIndex].meta.trueview = res.trueview as Blob;
				newMerch.decorations[decorationIndex].meta.stitches = res.stitches;
			} catch (e) {
				const message = await logError(e);
				setLocalToast({
					actionToast: {
						type: ActionToastType.Error,
						title: 'Pricing Issue',
						message,
					},
				});
			}
		}
		setMerch(newMerch);
		setUpdatingPrice(false);
	};

	return { calculateStitches, resetWilcomCallId };
}
